import axios from 'axios';
import Metadata from '../helpers/metadata/Metadata';
import recordDescriptorProcessing  from '../helpers/StoreFunctions/recordDescriptorProcessing';
import serviceUtil from './serviceUtil';

// Request deduplication cache
const requestCache = new Map();

let helpers = {
  getUsers: (page, perPage, sortField = '', ascending, seeSuspended, marketId, companyId, options) => {
    
    let url = process.env.REACT_APP_API + '/users?current_company=' + (companyId ? companyId : localStorage.current_company_id);
    if (marketId) {
      url += '&market='+marketId;
    }
    if (sortField) {
      url += '&order=' + sortField + (ascending ? ',asc' : ',desc');
    }
    if (page) {
      url += '&page=' + page + '&per=' + (perPage ? perPage : 11);
    }
    if(!seeSuspended){
      url += '&without_suspended=true';
    }
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: url,
      timeout: 120000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  getSuperAdminUsers: (adminCompany, options) => {
    let url = process.env.REACT_APP_API + '/admin/users/super_admins?current_company=' + adminCompany.id;

    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }

    return axios({
      method: 'get',
      url: url,
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  getUser: (user_id, company_id, options) => {
    let url = process.env.REACT_APP_API + '/users/' + user_id + '/show_new?current_company=' + localStorage.current_company_id + (company_id ? ('&company=' + company_id) : '');
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: url,
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  getUserByMarket: (company_id, markets) => {
    let url = process.env.REACT_APP_API + '/users/market_users?company_id=' + (company_id ? company_id : localStorage.current_company_id);

    if (markets) {
      markets.forEach(market => {
        url += '&market_ids[]=' + market.id;
      });
    }
    
    return axios({
      method: 'get',
      url: url,
      timeout: 60000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return { error: error };
    });
  },
  getVendorUsers: (page, perPage, sortField, ascending, options) => {
    let url = process.env.REACT_APP_API + '/users/vendors?current_company=' + localStorage.current_company_id;

    if (sortField) {
      url += '&order=' + sortField + (ascending ? ',asc' : ',desc');
    }
    else {
      url += '&order=';
    }
    if (page) {
      url += '&page=' + page + '&per=' + (perPage ? perPage : 12);
    }
    if (sortField) {
      url += '&order=' + sortField + (ascending ? ',asc' : ',desc');
    }
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }

    return axios({
      method: 'get',
      url: url,
      timeout: 60000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  getCurrentUser: (options) => {
    let url = process.env.REACT_APP_API + '/users/get_current_user?current_company=' + localStorage.current_company_id;
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }

    return axios({
      method: 'get',
      url: url,
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  createUser: (user, adminCompany, eventMetadatum, options) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const directory_id = user.directory ? user.directory.id : user.directory_id;
    delete user.directory;
    const company_id = user.company_id;
    delete user.directory_id;
    delete user.company_id;
    user.role_id = user.role ? user.role.id : user.role_id;
    delete user.role;
    let url = process.env.REACT_APP_API + '/users' + (user.password ? '' : '/create_without_password') + '?current_company=' + localStorage.current_company_id;
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'post',
      url: url,
      data: {
        event_metadatum: eventMetadatum,
        user: user,
        directory: directory_id,
        company: company_id,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return { error: error };
    });
  },
  createAdminUser: (user, adminCompany, eventMetadatum, options) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const directory_id = user.directory_id;
    user.super_admin = true;
    delete user.directory_id;
    delete user.company_id;
    delete user.markets;
    delete user.role;
    user.role_id = 1;
    user.password = 'changeme';
    user.password_confirmation = 'changeme';
    let url = process.env.REACT_APP_API + '/admin/users?current_company=' + localStorage.current_company_id;
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'post',
      url: url,
      data: {
        event_metadatum: eventMetadatum,
        user: user,
        directory: directory_id,
        company: 1,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  updateUser: (user, eventMetadatum, options) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    const company_id = user.companies && user.companies.length > 0 ? (user.companies[0].id ? user.companies[0].id : user.companies[0]) : localStorage.current_company_id;
    const directory_id = user.directory ? user.directory.id : user.directories && user.directories.length > 0 ? user.directories[0].id : null;
    delete user.companies;
    delete user.company;
    delete user.market_users;
    delete user.markets;
    delete user.directory;
    delete user.vendor_companies;
    user.role_id = user.role ? user.role.id : user.role_id;
    delete user.role;

    let url = process.env.REACT_APP_API + '/users/' + user.id + '?current_company=' + company_id;
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }

    return axios({
      method: 'patch',
      url: url,
      data: {
        event_metadatum: eventMetadatum,
        user: user,
        directory: directory_id,
        company: company_id,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return { error: error };
    });
  },
  deleteUser: (user_id, eventMetadatum) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/users/' + user_id + '?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return { error: error };
    });
  },
  getPermissions: () => {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/permissions?current_company=' + localStorage.current_company_id,
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data.permissions;
      })
      .catch(error => {
        return { error: error };
      });
  },

  getUserRoles: (company_id) => {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/roles?current_company=' + (company_id ? company_id : localStorage.current_company_id),
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data.roles;
      })
      .catch(error => {
        return { error: error };
      });
  },

  setUserRole: (user, role, company_id, eventMetadatum) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/roles/' + role.id + '/add_to_user?current_company=' + (company_id ? company_id : localStorage.current_company_id),
      data: {
        event_metadatum: eventMetadatum,
        user: { id: user.id },
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data.user;
      })
      .catch(error => {
        return { error: error };
      });
  },

  removeUserRole: (user, role, eventMetadatum) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/roles/' + role.id + '/remove_from_user?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        user: {  id: user.id },
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data.user;
      })
      .catch(error => {
        return { error: error };
      });
  },

  createVendorUser: (user, company_id, eventMetadatum, options) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    
    let url = process.env.REACT_APP_API + '/users/create_vendor?current_company=' + (company_id ? company_id : localStorage.current_company_id);
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'post',
      url: url,
      data: {
        event_metadatum: eventMetadatum,
        vendor_user: user,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  deleteVendorUser: (user, company_id, eventMetadatum) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/users/' + user.id + '/remove_vendor?current_company=' + (company_id ? company_id : localStorage.current_company_id),
      data: {
        event_metadatum: eventMetadatum,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return { error: error };
    });
  },
  checkPassword: (user, email, password, eventMetadatum) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'patch',
      url: `${process.env.REACT_APP_API}/users/${user.id}/check_password?current_company=${localStorage.current_company_id}`,
      data: {
        event_metadatum: eventMetadatum,
        email: email,
        password: password,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return { error: error };
    });
  },
  setPassword: (password, token, eventMetadatum) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/users/set-password',
      data: {
        event_metadatum: eventMetadatum,
        password: password,
        invitation_token: token,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + token,
      },
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return { error };
    });
  },
  sendInvite: (user) => {
    return axios({
      method: 'get',
      url: `${process.env.REACT_APP_API}/users/${user.id}/reinvite?current_company=${localStorage.current_company_id}`,
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return { status: 'success' };
    })
    .catch(error => {
      return { error: error };
    });
  },
  sendResetPasswordEmail: (email, eventMetadatum) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_API}/users/send_reset_password_email`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
      },
      data: {
        event_metadatum: eventMetadatum,
        email: email,
      },
    })
    .then(response => {
      return { status: 'success' };
    })
    .catch(error => {
      return { error: error };
    });
  },
  checkEmailAvailability: (email) => {
    email = encodeURIComponent(email);
    return axios({
      method: 'get',
      url: `${process.env.REACT_APP_API}/user/check_email?current_company=${localStorage.current_company_id}&email=${email}`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return { error: error };
    });
  },
  search: (searchString, companyId = '', userType = '', includeVendors = false, deactivated = false, sortField = '', ascending, page, perPage, options, loadingHandler) => {
    let url = process.env.REACT_APP_API + '/users/report?current_company=' + localStorage.current_company_id + (searchString ? '&keywords=' + searchString : '');
    if (sortField) {
      url += '&order=' + sortField + (ascending ? ',asc' : ',desc');
    }
    else {
      url += '&order=';
    }
    if (userType) {
      url += '&user_type=' + userType;
    }
    url += '&company_id=' + (companyId ? companyId : localStorage.current_company_id);
    url += '&include_suspended=' + deactivated; 
    url += '&include_vendors=' + includeVendors; 
    if (page && perPage) {
      url += '&page=' + page + '&per=' + (perPage ? perPage : 7);
    }
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }

    // Check if identical request is already in progress
    const cacheKey = url;
    if (requestCache.has(cacheKey)) {
      return requestCache.get(cacheKey);
    }

    const requestPromise = axios({
      method: 'get',
      url: url,
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        requestCache.delete(cacheKey);
        return { ...response.data, searchText: searchString };
      })
      .catch(error => {
        requestCache.delete(cacheKey);
        loadingHandler && loadingHandler();
        return { error: error };
      });

    requestCache.set(cacheKey, requestPromise);
    return requestPromise;
  },
  mobileUsersDirectory(options) {
    let url = process.env.REACT_APP_API + '/directories/mobile_directory?current_company=' + localStorage.current_company_id;
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: url,
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  addUserToMarket(userId, marketId, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_API}/markets/${marketId}/add_user?current_company=${localStorage.current_company_id}`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        user_id: userId,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return { error: error };
    });
  },
  deleteUserFromMarket(userId, marketId, eventMetadatum){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API}/markets/${marketId}/add_user?current_company=${localStorage.current_company_id}`,
      data: {
        event_metadatum: eventMetadatum,
        user_id: userId,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return { error: error };
    });
  },
  addVendorUserToMarket(userId, marketId, vendorCompanyId, eventMetadatum){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_API}/markets/${marketId}/add_vendor_user?current_company=${localStorage.current_company_id}`,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        user_id: userId,
        vendor_company_id: vendorCompanyId,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return { error: error };
    });
  },
  deleteVendorUserFromMarket(userId, marketId, vendorCompanyId, eventMetadatum){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API}/markets/${marketId}/remove_vendor_user?current_company=${localStorage.current_company_id}`,
      data: {
        event_metadatum: eventMetadatum,
        user_id: userId,
        vendor_company_id: vendorCompanyId,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return { error: error };
    });
  },
  getReportUser(searchString, companyId = '', userType = '', sortField = '', ascending, includeVendors = false, deactivated = false){
    let url = process.env.REACT_APP_API + '/users/user_report?current_company=' + localStorage.current_company_id;

    if(searchString){
      url += '&keywords=' + searchString;
    } 
    if (sortField) {
      url += '&order=' + sortField + (ascending ? ',asc' : ',desc');
    }
    else{
      url += '&order=';
    }
    if (userType) {
      url += '&user_type=' + userType;
    }
    if(companyId){
      url += '&company_id=' + companyId; 
    }
    url += '&include_suspended=' + deactivated;
    url += '&include_vendors=' + includeVendors;
    return axios({
      method: 'get',
      url: url,
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return { ...response.data };
      })
      .catch(error => {
        return { error: error };
      });
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/services/userService.js